import { render, staticRenderFns } from "./QuotaTimeSelect.vue?vue&type=template&id=2e131278"
import script from "./QuotaTimeSelect.vue?vue&type=script&lang=ts"
export * from "./QuotaTimeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports